import React, { useEffect } from "react"

import { InputText } from "../../../../../../components/input-text/input-text"
import { splitNames } from "../../../../../../modules/functions"

import "./style.scss"

export const Signature = (props: any) => {
    const { formik } = props

    // This is a hack as currently in the react-select library it is broken for tabbing on safari iOS before first selection
    const select = document.getElementById("react-select-count-input") as HTMLInputElement
    const firstName =
        splitNames(formik.values.name).first !== "" ? splitNames(formik.values.name).first : formik.values.name

    useEffect(() => {
        if (select !== undefined && select !== null) {
            select.style.opacity = "0"
        }
    }, [select])

    return (
        <div className="sig">
            <InputText
                id="name"
                className="form-item"
                label="Full name"
                focusMessage="Hi! Type in your full name to get started..."
                error={formik.errors.name}
                placeholder="Your full name"
                maxLength={100}
                value={formik.values.name}
                onChange={formik.handleChange}
            />
            <InputText
                id="position"
                className="form-item"
                label="Job title"
                focusMessage={
                    formik.values.name?.length > 0
                        ? `Welcome ${firstName}, what's your job title?`
                        : "Welcome, what's your job title?"
                }
                error={formik.errors.position}
                placeholder="Your job title"
                maxLength={100}
                value={formik.values.position}
                onChange={formik.handleChange}
            />
            <InputText
                id="workphone"
                className="form-item"
                label="Business phone"
                focusMessage="And what's your business phone number?"
                error={formik.errors.workphone}
                placeholder="Your business phone number"
                maxLength={30}
                type={"tel"}
                value={formik.values.workphone}
                onChange={formik.handleChange}
            />
            <InputText
                id="orgname"
                className="form-item"
                label="Business name"
                focusMessage="Now let's add your business name"
                error={formik.errors.orgname}
                placeholder="Your business name"
                maxLength={100}
                value={formik.values.orgname}
                onChange={formik.handleChange}
            />
            <InputText
                id="website"
                className="form-item"
                label="Business website"
                focusMessage="And add your business website"
                error={formik.errors.website}
                placeholder="Your business website"
                maxLength={120}
                value={formik.values.website}
                onChange={formik.handleChange}
                autoCapitalize="none"
            />
            <InputText
                id="email"
                className="form-item"
                label="Business email"
                focusMessage="What's your business email address?"
                error={formik.errors.email}
                placeholder="Your business email address"
                maxLength={100}
                value={formik.values.email}
                onChange={formik.handleChange}
                autoCapitalize="none"
            />
        </div>
    )
}
